/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/utils/AssetTypeUtil',['../nls/StringResources'], function (StringResources) {
	'use strict';

	// Based on https://jsw.ibm.com/browse/COLLAB-1584
	// Here's the label mapping that the content pages use:
	// dashboard CM Type -> "Workspace" 
	// exploration CM Type -> "Dashboard" 

	var ASSET_TYPE_MAP = Object.freeze({
		'explore': StringResources.get('asset_type_explore'),
		'exploration': StringResources.get('asset_type_dashboard'),
		'dashboard': StringResources.get('asset_type_dashboard'),
		'workspace': StringResources.get('asset_type_workspace'),
		'story': StringResources.get('asset_type_story'),
		'module': StringResources.get('asset_type_data'),
		'report': StringResources.get('asset_type_report'),
		'reportView': StringResources.get('asset_type_report'),
		'interactiveReport': StringResources.get('asset_type_report'),
		'dataSet2': StringResources.get('asset_type_dataset'),
		'folder': StringResources.get('asset_type_folder'),
		'uploadedFile': StringResources.get('asset_type_uploadedFile'),
		'package': StringResources.get('asset_type_package'),
		'jupyterNotebook': StringResources.get('asset_type_notebook')
	});

	var PERSPECTIVE_TYPE_MAP = Object.freeze({
		'authoring': StringResources.get('asset_type_report'),
		'dashboard': StringResources.get('asset_type_dashboard'),
		'datasets': StringResources.get('asset_type_dataset'),
		'explore': StringResources.get('asset_type_explore'),
		'notebook': StringResources.get('asset_type_notebook'),
		'story': StringResources.get('asset_type_story'),
		'ca-modeller': StringResources.get('asset_type_data'),
		'classicviewer': StringResources.get('asset_type_report'),
		'uploadedFile': StringResources.get('asset_type_uploadedFile'),
		'package': StringResources.get('asset_type_package')
	});

	/**
  * A util class that maps asset types and perspectives to localized strings
  * @constructor
  */
	function AssetTypeUtil() {}

	/**
  * Gets localized asset type string.
  * @param {string} type - the asset type
  * @return {string} localized asset type
  */
	AssetTypeUtil.prototype.getLocalizedType = function (type) {
		return ASSET_TYPE_MAP[type];
	};

	/**
  * Gets localized asset type string by perspective.
  * @param {string} perspective
  * @return {string} localized asset type
  */
	AssetTypeUtil.prototype.getLocalizedTypeByPerspective = function (perspective) {
		return PERSPECTIVE_TYPE_MAP[perspective];
	};

	return new AssetTypeUtil();
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

